import { render } from "./DefaultContent.vue?vue&type=template&id=66d10a67&scoped=true&ts=true"
import script from "./DefaultContent.vue?vue&type=script&lang=ts"
export * from "./DefaultContent.vue?vue&type=script&lang=ts"

import "./DefaultContent.vue?vue&type=style&index=0&id=66d10a67&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d10a67"]])

export default __exports__